import gql from 'graphql-tag';

export const SearchTripDocument = gql`
  query SearchTripDocument($input: TripDocumentWithCacheConnectionInput) {
    searchTripDocument {
      tripDocumentWithCacheConnection(input: $input) {
        totalCount
        edges {
          node {
            contentType
            createdAt
            createdBy
            createdByFirstName
            createdByLastName
            deletedAt
            deletedBy
            fileLocation
            fileSize
            filename
            id
            md5
            traceId
            tripId
            updatedAt
            updatedBy
            deletedByFirstName
            deletedByLastName
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
